/**
 * Resolve which nominee section should render category-specific questions for a set.
 * Falls back to the first nominee section when unset or invalid.
 */
export function getFirstNomineeSectionKey(sections = []) {
  const hit = (sections || []).find(
    (s) => String(s?.audience || 'NOMINEE').toUpperCase() === 'NOMINEE'
  );
  return hit ? String(hit.key || '') : '';
}

export function resolveCategoryQuestionsSectionKey(cqs, sections = []) {
  const first = getFirstNomineeSectionKey(sections);
  const nomineeKeys = new Set(
    (sections || [])
      .filter((s) => String(s?.audience || 'NOMINEE').toUpperCase() === 'NOMINEE')
      .map((s) => String(s?.key || ''))
      .filter(Boolean)
  );
  const requested = String(cqs?.sectionKey || '').trim();
  if (requested && nomineeKeys.has(requested)) return requested;
  return first;
}
